import { ITinymedicPatientOrder } from 'app/shared/model/tinymedic-patient-order.model';
import { ITenant } from 'app/shared/model/tenant.model';
import { BidStatus } from 'app/shared/model/enumerations/bid-status.model';
import { BillFor } from 'app/shared/model/enumerations/bill-for.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';

export interface ITenantBids {
  id?: string;
  status?: keyof typeof BidStatus;
  createdById?: string | null;
  createdByType?: string;
  billFor?: keyof typeof BillFor | null;
  patientType?: keyof typeof PatientType | null;
  bidSubmittedDate?: number | null;
  bidAcceptedDate?: number | null;
  totalCost?: number | null;
  discount?: number | null;
  cgst?: number | null;
  sgst?: number | null;
  roundOffVal?: number | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  homeDeliveryAvailable?: boolean;
  deliveryTime?: string | null;
  deliveryCost?: number | null;
  grossAmount?: number | null;
  bidNumber?: string | null;
  bidDate?: number | null;
  tinymedicPatientOrder?: ITinymedicPatientOrder | null;
  tenant?: ITenant | null;
}

export const defaultValue: Readonly<ITenantBids> = {
  active: false,
  homeDeliveryAvailable: false,
};
